
import 'angular-jquery-timepicker';
import CreateJobScheduleDirective from './_form-schedule.directive';
import JobCreateController from './job.create.controller';
import { JobDeleteModalController, JobDetailController } from './job.detail.controller';
import JobUpdateController from './job.update.controller';

const jobModule = angular.module('app.jobschedules.job', [
    'ui.timepicker'
])
.directive('createJobSchedule', [ CreateJobScheduleDirective ])
.controller('JobCreateController', JobCreateController)
.controller('JobDeleteModalController', JobDeleteModalController)
.controller('JobDetailController', JobDetailController)
.controller('JobUpdateController', JobUpdateController);

export default jobModule.name;
